import classNames from "classnames";
import { useRef, useState } from "react";
import useOutsideAlerter from "../hooks/use_outside_alerter";

export function WithDropdown(props: {
	children: React.ReactNode;
	items: JSX.Element[];
}) {
	const [is_active, setIsActive] = useState(false);

	const trigger_ref = useRef<HTMLDivElement>(null);

	useOutsideAlerter(trigger_ref, () => setIsActive(false));

	return (
		<div
			ref={trigger_ref}
			className={classNames("dropdown", { "is-active": is_active })}
		>
			<div className="dropdown-trigger">
				<button
					className="flex items-center gap-2"
					aria-haspopup="true"
					aria-controls="dropdown-menu"
					onClick={() => setIsActive(true)}
				>
					{props.children}
					<span className="icon is-small">
						<i className="fas fa-angle-down" aria-hidden="true"></i>
					</span>
				</button>
			</div>
			<div
				className="dropdown-menu w-min rounded-sm bg-base-light shadow-md"
				id="dropdown-menu"
				role="menu"
			>
				{props.items.map((val, index) => (
					<div key={index} className="dropdown-item w-full">
						{val}
					</div>
				))}
			</div>
		</div>
	);
}
